import { Flex } from '@chakra-ui/react';
import { useWalletConnectModalStore } from '@cronos-app/components';
import { ChainLayer } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { DEFAULT_CONTENT_WIDTH_DESKTOP } from '@ui/configs/ui';
import { SEOTemplate } from '@ui/SEO';
import { dynamicWithLoading } from '@ui/utils/dynamicWithLoading';
import React, { useEffect } from 'react';

import { CardView } from './core/types';
import { useCardContextStore } from './core/useCardContextStore';
import { useCdcCardView } from './core/useCdcCardView';
import { useCdcDepositAddress } from './core/utils';
import { useSwapAndTopUpArgs_test } from './core/utils/useSwapAndTopUpArgs_test';
import { CardBindingModal } from './Cronos/CardBinding';
import { CdcCardFirstView } from './Cronos/CdcCardFirstView';
import { CdcCardSecondView } from './Cronos/CdcCardSecondView';
import { TopNavbar } from './TopNavbar';

const WalletConnectModal = dynamicWithLoading(() =>
  import('@ui/components/Wallet').then((mod) => mod.WalletConnectModal),
);

export const Page = () => {
  const isOpenWalletModalOpen = useWalletConnectModalStore((s) => s.isOpen);
  const network = currentWallet.useDesiredNetwork();
  const { view, setView } = useCdcCardView();
  useEffect(() => {
    useCardContextStore.getState().setLayer(ChainLayer.CronosEvm, network);
  }, [network]);
  useSwapAndTopUpArgs_test();

  const { data: card } = useCdcDepositAddress();
  useEffect(() => {
    if (view === CardView.First) return;
    if (card) return;
    setView(CardView.First);
  }, [card, setView, view]);
  return (
    <>
      <SEOTemplate
        title="Seamlessly Top Up Your Crypto.com Card with Cronos EVM"
        description="Easily fund your Crypto.com Card using the Cronos EVM chain. Link your non-custodial wallet, and top up with just a few clicks. Get started now!"
      />
      <TopNavbar />
      {isOpenWalletModalOpen && <WalletConnectModal />}
      <Flex
        flexDir="column"
        pt={{ base: 6, desktop: 8 }}
        mx="auto"
        maxW={DEFAULT_CONTENT_WIDTH_DESKTOP}
        minH={{ base: '100vh', desktop: 'unset' }}
      >
        {view === CardView.First ? <CdcCardFirstView /> : <CdcCardSecondView />}
        <CardBindingModal />
      </Flex>
    </>
  );
};
